import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/query/react";

import {
  CreateUserRequest,
  GetUsersRequest,
  UpdateUserRequest,
} from "api/types/requests";
import User from "api/types/models/user";
import QueryTags from "api/types/QueryTags";

const userEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      {},
      FetchBaseQueryMeta
    >,
    QueryTags,
    "data"
  >,
) => ({
  getUser: builder.query<User, number>({
    query: (id) => `/users/${id}`,
    providesTags: ["User"],
  }),

  getUsers: builder.query<User[], GetUsersRequest | undefined>({
    query: (params) => ({
      url: "/users",
      params,
    }),
    providesTags: ["Users"],
  }),

  createUser: builder.mutation<User, CreateUserRequest>({
    query: (body) => ({
      url: "/users",
      method: "post",
      body,
    }),
    invalidatesTags: ["Users"],
  }),

  updateUser: builder.mutation<User, { id: number; body: UpdateUserRequest }>({
    query: ({ id, body }) => ({
      url: `/users/${id}`,
      method: "put",
      body,
    }),
    invalidatesTags: ["Users", "User"],
  }),

  deleteUser: builder.mutation<void, number>({
    query: (id) => ({
      url: `/users/${id}`,
      method: "delete",
    }),
    invalidatesTags: ["Users"],
  }),
});

export default userEndpoints;
